/* eslint-disable import/first */

// Axios and authentication
import './http';

// Vue.js
import Vue from 'vue';

// Vue Material
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.css';

Vue.use(VueMaterial);

Vue.material.registerTheme({
  default: {
    primary: {
      color: 'light-blue',
      hue: 'A700',
    },
    accent: 'blue',
    warn: 'red',
  },
  white: {
    primary: 'white',
    accent: 'blue',
  },
});

// moment
import moment from 'moment';
import 'moment/locale/nb';
window.moment = moment;
moment.locale('nb');

// lodash
window._ = require('lodash');

// Lightbox 2
import 'lightbox2/dist/css/lightbox.min.css';
const lightbox = require('lightbox2');

lightbox.option({
  wrapAround: true,
});

// Basscss
import 'basscss/css/basscss.min.css';

// Application styles
import '../scss/app.scss';

// Components
import './components';

// Helpers
import './helper';



// WEBPACK FOOTER //
// ./src/js/bootstrap.js